export default __webpack_public_path__ + "static/ephemeral-processing-m-269479ee8914d003eb02894c9362c1fa.webp";